import React from "react";
import ChildrenProps from "@lib-shared/types/children-props";
import LightSpinner from "./light-spinner";

type LoadedContentProps = {
    isLoading: boolean
} & ChildrenProps & ClassNameProps;

const LoadedContent = (props: LoadedContentProps) => {
    const className = props.className != null ? props.className : "loader";

    if (props.isLoading) {
        return (
            <div className={className}>
                <LightSpinner />
            </div>
        );
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{props.children}</>;
}

export default LoadedContent;
